<!DOCTYPE html>
<ion-header>
    <ion-toolbar>
        <mat-icon class="back-arrow" (click)="goBack()">keyboard_backspace</mat-icon>
        <h1>{{ "suggestions.title" | translate }}</h1>
        <h2 class="small-title">
            <i>{{ "suggestions.sub_title" | translate }}</i>
        </h2>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-card (click)="openTypeForm(typeFormData.lottery)">
        <div class="card-container">
            <div class="image-container">
                <img alt="Abstract lottery-themed design"
                    src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Flottery_experience_400x400.webp?alt=media"
                    loading="lazy" />
            </div>
            <div class="card-body">
                <ion-card-header>
                    <ion-card-title>{{ "suggestions.lottery_title" | translate }}</ion-card-title>
                    <ion-card-subtitle>{{ "suggestions.lottery_sub_title" | translate }}</ion-card-subtitle>
                </ion-card-header>
                <ion-card-content>
                    {{ "suggestions.lottery_description" | translate }}
                </ion-card-content>
            </div>
        </div>
    </ion-card>

    <ion-card (click)="openTypeForm(typeFormData.games)">
        <div class="card-container">
            <div class="image-container">
                <img alt="Abstract gaming-themed design"
                    src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Fgame_experience_400x400.webp?alt=media"
                    loading="lazy" />
            </div>
            <div class="card-body">
                <ion-card-header>
                    <ion-card-title>{{ "suggestions.games_title" | translate}}</ion-card-title>
                    <ion-card-subtitle>{{ "suggestions.games_sub_title" |translate }}</ion-card-subtitle>
                </ion-card-header>
                <ion-card-content>
                    {{ "suggestions.games_description" | translate }}
                </ion-card-content>
            </div>
        </div>
    </ion-card>

    <ion-card (click)="openTypeForm(typeFormData.support)">
        <div class="card-container">
            <div class="image-container">
                <img alt="Abstract support-themed design"
                    src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Fsupport_experience_200x200.webp?alt=media"
                    loading="lazy" />
            </div>
            <div class="card-body">
                <ion-card-header>
                    <ion-card-title>{{ "suggestions.support_title" | translate}}</ion-card-title>
                    <ion-card-subtitle>{{ "suggestions.support_sub_title" |translate }}</ion-card-subtitle>
                </ion-card-header>
                <ion-card-content>
                    {{ "suggestions.support_description" | translate }}
                </ion-card-content>
            </div>
        </div>
    </ion-card>

    <ion-card (click)="openTypeForm(typeFormData.social)">
        <div class="card-container">
            <div class="image-container">
                <img alt="Abstract community-themed design"
                    src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Fsocial_experience_400x400.webp?alt=media"
                    loading="lazy" />
            </div>
            <div class="card-body">
                <ion-card-header>
                    <ion-card-title>{{ "suggestions.social_title" | translate }}</ion-card-title>
                    <ion-card-subtitle>{{ "suggestions.social_sub_title" |translate }}</ion-card-subtitle>
                </ion-card-header>
                <ion-card-content>
                    {{ "suggestions.social_description" | translate }}
                </ion-card-content>
            </div>
        </div>
    </ion-card>
</ion-content>
